import React from 'react'
import './Projects.css'
import Icons from '../Icons/Icons'

const Projects = () => {

  const proyectos = [
    {
      title:'ControlStore',
      description:'E-commerce sobre una tienda de videojuegos. Lleva panel de administrador y paginación.',
      languages: ['Express', 'Mongodb'],
      link: 'https://controlstore.onrender.com',
      github:'https://github.com/gonzaloezemolina/controlStore'
    },
    // {
    //   title:'Análisis de campañas de email Marketing',
    //   description: 'CRUD sencillo gestionando creación de cliente y proyectos',
    //   languages: ['Express', 'MongoDB']
    // },
    // {
    //   title:'Social Media Manager',
    //   description: 'Plataforma para programar publicaciones en redes sociales',
    //   languages: ['Django']
    // },
    // {
    //   title:'Dingo',
    //   description: 'CRM Para Freelancers y agencias. Cuenta con gestor de proyectos, contactos y más.',
    //   languages: ['Express', 'PostgreSQL']
    // },
  ]


  return (
    <div className='project_component'>
        <h2>Proyectos</h2>

        <div className='below'>
            <p>
                A continuación, encontrarás mis proyectos junto con los lenguajes de programación que utilicé para cada uno. Puedes ver el resultado clickeando el ojo y puedes obtener el codigo presionando el icono de GitHub.
            </p>
        </div>

<div id='projects_container'>

    {proyectos.map((pro) => {
      return (
      <div className='project_card'>
      <div className="card_firstline">
      
                <div className='project_card_title'>
                      <h3>{pro.title}</h3>
                  </div>
      
                  <div className='project_card_options'>
                    <a className='card_links' href={pro.link} target='blank'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16" id='watch'>
        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
      </svg>
                    </a>
                    <a className='card_links' href={pro.github} target='blank'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-github" viewBox="0 0 16 16" id='watch'>
        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8"/>
      </svg>
                    </a>
                      </div>
                </div>
                  <div className='project_description'>
                      <p>{pro.description}</p>
                  </div>
                  <div id='project_languages'>
                    {pro.languages.map((lang,index)=> (
                      <Icons key={index} type={lang}/>
                    ))}
                  </div>
              </div>
      );
    })}
</div>
    </div>
  )
}

export default Projects